import { checkResponse, get, post,  e } from '@/helpers/http.js'

export function getPlayables (data) {
  return get(e('/api/v1/playable'), data)
    .then(checkResponse)
}

export function getPlayable (playableId, data) {
  return get(e(`/api/v1/playable/${playableId}`), data)
    .then(checkResponse)
}

export function updatePLayableScreenshots (playableId) {
  return post(e(`/api/v1/playable/${playableId}/update_screenshots`))
    .then(checkResponse)
}
